import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";

import styles from 'views/component/Styles.js';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const useStyles = makeStyles(styles);

export default function CheckBoxSelect(props) {
    const { title, items, handleItemClick, selectedItemList, fullWidth } = props;
    const [selectedItem, setSelectedList] = useState(selectedItemList);

    const handleMultipleSelect = event => {
        setSelectedList(event.target.value);
    };

    const handleItemToggle = value => {
        handleItemClick(value);
    };

    useEffect(() =>{
        setSelectedList(selectedItemList);
    }, [selectedItemList]);

    const classes = useStyles();
    return (<FormControl fullWidth={fullWidth} className={classes.selectFormControlInfo}>
        {title ? <InputLabel className={classes.selectLabel}>{title}</InputLabel> : ''}
        <Select multiple 
            MenuProps={{ className: classes.selectMenu, classes: { paper: classes.selectPaper } }}
            classes={{ select: classes.select }}
            value={selectedItem}
            onChange={handleMultipleSelect}
            renderValue={(selectedItemList) => {
                let itemList = [];
                items.map(item => {
                    if (selectedItemList.includes(item.value) === true) {
                        itemList.push(item.name);
                    }
                });
                return itemList.join(', ');
            }}>
            {items.map(element =>
                <MenuItem
                    key={element.value} value={element.value}
                    classes={{ root: classes.selectMenuItemInfo, selected: classes.selectMenuItemSelectedMultipleInfo }}
                    onClick={() => handleItemToggle(element.value)}
                    selected={selectedItemList.indexOf(element.value) > -1}>
                    {element.name}
                </MenuItem>
            )}
        </Select>
    </FormControl>);
}

CheckBoxSelect.propTypes = {
    items: PropTypes.arrayOf(PropTypes.any),
    handleItemClick: PropTypes.func,
    selectedItemList: PropTypes.arrayOf(PropTypes.any),
    fullWidth: PropTypes.bool
};